<template>
	<div class="col-12 col-md-6 col-lg-4 mb-4">
		<div class="card document-card">
			<strong class="mb-3">{{ field.name }}</strong>
			<div v-if="field.children">
				<base-field
					v-for="childField in field.children"
					:key="childField.field_id"
					ref="childFields"
					:field="childField"
					:person-number="personNumber"
					:form-data="formData"
					:group="field.slug"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { CHECKOUT_STORE_NAMESPACE, MUTATION_SET_FORM_FIELDS_DATA } from '@/store/checkout';

export default {
	name: 'FieldGroup',
	components: { BaseField: () => import(/* webpackChunkName: "base-field" */'../CheckoutBaseField.vue') },
	props: {
		field: {
			type: Object,
			default: () => {
			},
		},
		personNumber: {
			type: Number,
			default: 1,
		},
		formData: {
			type: Object,
			default: () => {
			},
		},
		additionalData: {
			type: Object,
			default: () => {
			},
		},
		value: { default: null },
	},
	methods: {
		checkChildrenValidation(form) {
			this.isValidateChildren = true;
			if (Array.isArray(this.$refs.childFields)) {
				this.$refs.childFields.forEach((field) => {
					if (typeof field.checkValidation === 'function') {
						const isValid = field.checkValidation(form);
						if (isValid === false) this.isValidateChildren = false;
					}
				});
			}
		},
		approveChildrenValidation() {
			if (Array.isArray(this.$refs.childFields)) {
				this.$refs.childFields.forEach((field) => {
					if (typeof field.checkValidation === 'function') {
						field.approveValidation();
					}
				});
			}
		},
		/**
		 * Проверяем валидность по библиотеке vuelidate
		 * @param form Oбъект, сгенерированный vuelidate, содержит инфу об ошибках
		 */
		checkValidation(form) {
			this.isValidate = typeof form[this.field.slug]?.$error !== 'undefined'
				? !form[this.field.slug]?.$error
				: true;
			if (this.isValidate === false) this.uploadError = true;

			if (this.laterUpload) {
				this.isValidate = true;
				this.uploadError = false;
			}

			this.checkChildrenValidation(form);

			return this.isValidate && this.isValidateChildren;
		},
		getChildrenValues() {
			if (!Array.isArray(this.$refs.childFields)) {
				return null;
			}
			return this.$refs.childFields.reduce((acc, field) => {
				if (!field.field?.slug) return acc;

				acc[field.field.slug] = field.fieldValue;

				return acc;
			}, {});
		},
	},
};
</script>

<style  lang="scss" scoped>
 @import "~/assets/styles/components/home/prog-registration";

	.document-card {
		text-align: left !important;
		padding: 20px !important;
	}
    .additional-document {
        padding: 20px;
		margin-bottom: 20px;
    }
    .additional-document-row > div + div {
        margin-left: 10px;
    }
    .additional-document-icon {
        position: relative;
        top: 5px;
    }

	.document-input-container {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 5px;
		margin-left: 10px;
	}
	.document-input {
		opacity: 0;
		position: absolute;
		left: 0px;
	}
	.document-upload-error {
		color: red;
	}
</style>
